<partner-header (navigateToLoginSignUp)="navigatePartnerSignIn($event)"></partner-header>

<router-outlet></router-outlet>

<app-footer *ngIf="!loginState"></app-footer>